// ============================================
// INFRASTRUCTURE - Tutoriales Repository
// ============================================

import { axiosClient } from './axios-client';
import type { ModuloTutorial, TutorialModulo } from '../../domain/dtos';

export const tutorialesRepository = {
  /**
   * Obtiene la lista de módulos con tutoriales disponibles
   */
  async obtenerModulos(): Promise<ModuloTutorial[]> {
    const response = await axiosClient.get<ModuloTutorial[]>('/tutoriales/modulos');
    return response.data;
  },

  /**
   * Obtiene los detalles de un módulo de tutoriales específico
   * @param moduleName - Nombre del módulo
   */
  async obtenerTutorialPorModulo(moduleName: string): Promise<TutorialModulo> {
    const response = await axiosClient.get<TutorialModulo>('/tutoriales', {
      params: { moduleName }
    });
    return response.data;
  },
};
